import { Field, Text, RichText } from "@sitecore-jss/sitecore-jss-nextjs";

import clsx from "clsx";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import * as Flex from "@repo/ui/flex";
import { useChatbotContext } from "../../../providers/chatbot-provider";
import styles from "./get-in-touch.module.css";

type ContentProps = ComponentProps & {
  fields: {
    data: {
      contextItem: {
        title: Field<string>;
        paragraph: Field<string>;
      };
    };
  };
};

const Content = ({
  fields: {
    data: {
      contextItem: { title, paragraph },
    },
  },
}: ContentProps) => {
  const { isChatbotActive } = useChatbotContext();

  if (isChatbotActive) return null;

  return (
    <Flex.Container column gap="md">
      <Text
        tag="h1"
        field={title}
        className={clsx("typographyHeading1", styles.title)}
      />
      <RichText
        tag="p"
        field={paragraph}
        className={clsx("typographyBody3Sentence", styles.description)}
      />
    </Flex.Container>
  );
};

export default Content;
